import React from 'react';
import { partial } from 'lodash';
import { InputItem } from '../../Forms/InputItem';
import { SwitchItem } from '../../Forms/SwitchItem';
import { FormTooltip } from '../../Forms/InputTooltip';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { InlineForm, SmallInputWrapper } from './styles';
import { SWITCH_DIRECTION, FORM_MARGIN, SUPPORT_LINKS } from './constants';

interface IProps {
  freeShipping: IShopSalesAutomation['freeShipping'];
  currency: string;
  updateFormValue: (path: string, value: unknown) => void;
}

export const FreeShippingSection = React.memo(
  ({ freeShipping, currency, updateFormValue }: IProps) => (
    <InlineForm>
      <SwitchItem
        value={freeShipping?.enabled}
        changeCallback={partial(updateFormValue, 'freeShipping.enabled')}
        label={getTranslationKey('collectionShop.freeShippingLabel')}
        direction={SWITCH_DIRECTION}
        margin={FORM_MARGIN}
        id="freeShipping-switch"
      />

      <SmallInputWrapper>
        <InputItem
          pattern={/^[0-9]+$/i}
          changeCallback={partial(updateFormValue, 'freeShipping.startsFrom')}
          value={freeShipping?.startsFrom}
          placeholder="-"
          min={0}
          step="0.1"
          margin="0"
          rightAddonElement={currency}
          id="freeShipping-switch-input"
        />

        <FormTooltip
          isShow
          formTheme="main"
          tooltipText={getTranslationKey('learnMoreLink', {
            link: SUPPORT_LINKS.freeShipping,
            text_link: SUPPORT_LINKS.freeShipping
          })}
          tooltipID="freeShipping-switch"
        />
      </SmallInputWrapper>
    </InlineForm>
  )
);
